import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import Actions from 'components/actions/Actions'
import { ICON_FLAME, ICON_SNOWFLAKE } from 'components/common/Icon'

const CrushActions = props => {
  const { onLike, onDislike } = props

  return (
    <Div width="50%" display="flex">
      <Actions
        actions={[
          {
            key: 'dislike',
            icon: ICON_SNOWFLAKE,
            onClick: onDislike,
            size: 48
          },
          { key: 'like', icon: ICON_FLAME, onClick: onLike }
        ]}
      />
    </Div>
  )
}

CrushActions.propTypes = {
  onLike: PropTypes.func.isRequired,
  onDislike: PropTypes.func.isRequired
}

export default CrushActions



// WEBPACK FOOTER //
// ./src/components/actions/CrushActions.js